import * as React from "react";
import {
    getRoutePath,
    redirectToRoutePath,
    sectionClasses,
    formatPhoneNumber,
    showCtaAndLegalSections,
    hideCtaAndLegalSections
} from "../common/Utils";
import {
    insuredSinceLengthToDescriptionString
} from "../common/Enums";
import { WizardStep } from "../common/WizardStep";
import { IStepProps } from "../interfaces/IStepProps";
import { IStepState } from "../interfaces/IStepState";
import { PreFilledQuoteModel } from "../interfaces/PreFilledQuoteModel";

declare const preFilledQuoteData: PreFilledQuoteModel;

export class PreFilledQuoteStep extends React.Component<IStepProps, IStepState> {

    state: IStepState;

    constructor(props: IStepProps) {
        super(props);

        this.state = {
            redirectPath: "",
            goToNextStep: false
        }

        showCtaAndLegalSections();
    }

    handleEditClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        hideCtaAndLegalSections();
        redirectToRoutePath(getRoutePath(WizardStep.PRIMARY_VEHICLE_YEAR));
    }

    render(): JSX.Element {
        if (this.state.goToNextStep) {
            redirectToRoutePath(this.state.redirectPath);
            return null;
        }

        const sectionStyle = {
            display: 'block'
        }

        const confirmHeaderStyle = {
            backgroundColor: "#eee",
            textAlign: "center" as "center",
            padding: "5px",
            borderRadius: "3px"
        }

        const headerStyle = {
            textAlign: "center" as "center",
            marginBottom: "10px"
        };

        const headerH3Style = {
            padding: "0"
        };

        const lineItemStyle = {
            padding: "5px 0"
        };

        const editLinkStyle = {
            textDecoration: "underline",
            cursor: "pointer"
        };

        return <div id="PreFilledQuoteStep" className={sectionClasses} style={sectionStyle}>
            <div style={headerStyle}>
                <h2><span>Almost Finished!</span></h2>
                <p>We have all the info we need to get you a great rate!</p>
            </div>
            <div className="header" style={confirmHeaderStyle}>
                <h3 style={headerH3Style}>Please confirm your information</h3>
            </div>
            <div id="PreFilledQuote">
                <p style={lineItemStyle}>
                    <strong>Primary Vehicle</strong>
                    <br />
                    {preFilledQuoteData.PrimaryVehicleYear} {preFilledQuoteData.PrimaryVehicleMake} {preFilledQuoteData.PrimaryVehicleModel}
                </p>
                <p style={lineItemStyle}>
                    <strong>Current Insurer:</strong>
                    <br />
                    {preFilledQuoteData.InsuranceCarrier}
                </p>
                <p style={lineItemStyle}>
                    <strong>ZIP Code:</strong>
                    <br />
                    {preFilledQuoteData.ZipCode}
                </p>
                <p style={lineItemStyle}>
                    <strong>Phone:</strong>
                    <br />
                    {formatPhoneNumber(preFilledQuoteData.Phone)}
                </p>
                <hr />
                <p><a style={editLinkStyle} onClick={this.handleEditClick}>Edit profile</a></p>
            </div>
        </div>;
    }
}